export default {
  id: null,
  name: '',
  email: '',
  rfc: '',
  companyName: '',
  oldRfc: '',
  count: 0,
  page: 1,
  size: 20,
  csv: null,
  csvFileName: '',
  list: [],
  loading: false,
  success: '',
  message: false,
  creditDays: 0,
  creditLimit: 0,
  cellphoneNumber: '',
  zipCode: '',
  taxRegime: '',
  debts: [],
  debtsExpired: [],
  temporal: {
    customerId: 0,
    companyId: 0,
    debts: [],
    debtsExpired: [],
    creditLimit: 0,
    name: '',
    email: '',
    creditDays: '',
    rfc: '',
    companyName: '',
  },
};
